import { IDocuments } from './IDocuments';
import { DocumentMapper } from './mapper';

/**
 * check the document result property and create a model with help of mapper class
 * @param   {array} data search api response
 */
export class DocumentsModel {
  documentData: Array<IDocuments> = [];

  constructor(documentData: any = []) {
    if (documentData) {
      const transModel = new DocumentMapper(documentData);
      this.documentData.push(transModel.documentItem);
    }
  }
}
